"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Person = _interopRequireDefault(require("@quintoandar/cozy-icons/Person"));
var _Document = _interopRequireDefault(require("@quintoandar/cozy-icons/Document"));
var _Help = _interopRequireDefault(require("@quintoandar/cozy-icons/Help"));
var _CalendarEvent = _interopRequireDefault(require("@quintoandar/cozy-icons/CalendarEvent"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _Typography = _interopRequireDefault(require("../../../Typography"));
var _Link = _interopRequireDefault(require("../../../Link"));
var _Box = _interopRequireDefault(require("../../../Box"));
var _Alert = _interopRequireDefault(require("../../../Alert"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ModalContent = function ModalContent(_ref) {
  var name = _ref.name,
    initDate = _ref.initDate,
    endDate = _ref.endDate,
    owner = _ref.owner,
    docLink = _ref.docLink;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: '412px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: _js["default"].alias.spacing.small
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "default",
    level: "title"
  }, name)), /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    kind: "warning",
    ariaLabel: "Warning Alert"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "default"
  }, "This component is ", /*#__PURE__*/_react["default"].createElement("b", null, "EXPERIMENTAL"), "!")), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: _js["default"].alias.spacing.medium
  }, /*#__PURE__*/_react["default"].createElement(_CalendarEvent["default"], {
    color: "action"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pl: _js["default"].alias.spacing.xxsmall
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "default"
  }, "Experiment sarted on: ", /*#__PURE__*/_react["default"].createElement("b", null, initDate)))), endDate && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: _js["default"].alias.spacing.medium
  }, /*#__PURE__*/_react["default"].createElement(_CalendarEvent["default"], {
    color: "action"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pl: _js["default"].alias.spacing.xxsmall
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "default"
  }, "Expected end on: ", /*#__PURE__*/_react["default"].createElement("b", null, endDate)))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: _js["default"].alias.spacing.medium
  }, /*#__PURE__*/_react["default"].createElement(_Person["default"], {
    color: "action"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pl: _js["default"].alias.spacing.xxsmall
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    as: "span",
    kind: "default"
  }, "Owner: ", /*#__PURE__*/_react["default"].createElement("b", null, owner.developer), " from ", /*#__PURE__*/_react["default"].createElement("b", null, owner.team)))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: _js["default"].alias.spacing.medium
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    color: "action"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pl: _js["default"].alias.spacing.xxsmall
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "default"
  }, "In case of any doubts, reach out ", owner.developer, " or cozy team on", ' ', /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    message: "Cozy-Dev",
    ariaLabel: "Cozy-Dev chanel",
    href: "https://chat.google.com/room/AAAAnm6Kw54?cls=7"
  }), ' ', "space"))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: _js["default"].alias.spacing.medium
  }, /*#__PURE__*/_react["default"].createElement(_Document["default"], {
    color: "action"
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pl: _js["default"].alias.spacing.xxsmall
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    message: "Documentation",
    ariaLabel: "Documentation link",
    href: docLink
  }))));
};
var _default = exports["default"] = ModalContent;